export default "__VITE_ASSET__D1l60ahI__"